/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import report
import ListReportPromo from '../views/report-promo/ListReportPromo.vue';
import { setBreadcrumb } from './index';

const reportPromoRoute = {
  path: '/report-promo',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Report Promo',
        appBarTitle: 'Report Promo',
        breadcrumbs: () => [
          setBreadcrumb('Report Promo', '/report-promo', true),
          setBreadcrumb('List Report Promo', '/report-promo'),
        ],
      },
      component: ListReportPromo,
      name: 'ListReportPromo',
    },
  ],

  meta: {
    title: 'BNI QRIS - Report Promo',
    appBarTitle: 'Report Promo',
  },
  component: Parent,
};

export default reportPromoRoute;
